/**
 * Общие токены оформления SVG/HTML-графиков всех отчётов.
 * Цвета серий валидированы против светлой поверхности (#fff).
 */

// Категориальные цвета серий — назначаются в фиксированном порядке
export const SERIES_BLUE = '#2a78d6';
export const SERIES_GREEN = '#1baf7a';
export const SERIES_YELLOW = '#eda100';

// Палитра для динамических наборов серий (например, причины штрафов).
// Цвет назначается по порядку появления; палитра циклична
export const CHART_PALETTE = [
	'#2a78d6',
	'#7c3aed',
	'#0e9f6e',
	'#eda100',
	'#0891b2',
	'#d61f69',
	'#c2410c',
	'#6b7280',
];

// Ординальная рампа (одна тональность, светлое → тёмное) — для упорядоченных
// ступеней одной сущности: этапы воронки, уровни и т. п.
export const ORDINAL_BLUE_RAMP = ['#86b6ef', '#5598e7', '#2a78d6', '#1c5cab'];

// Семантика знака (прибыль/убыток) — совпадает с pnl-cell--positive/negative таблиц
export const SIGN_POSITIVE = '#2e7d32';
export const SIGN_NEGATIVE = '#c62828';

// Референсные линии (скользящая средняя и т. п.) — намеренно серые
export const COLOR_MA = '#898781';

// Чернила и хром
export const INK_SECONDARY = '#52514e';
export const INK_MUTED = '#898781';
export const GRID_COLOR = '#e1e0d9';
export const BASELINE_COLOR = '#c3c2b7';
export const SURFACE = '#ffffff';

// Подсветка выходных дней на временных осях — бледная, чуть теплее сетки
export const WEEKEND_BAND = '#f4f3ee';
